
import { DomSanitizer } from "@angular/platform-browser";
import  moment from 'moment';


export const emailOnlyName = function (v: string) {

  try {
    v = v.toUpperCase();
    return v.split('@')[0];
  } catch (error) {
    return v;
  }

}

// copiato da program-mobile/src/app/shared.ts: genera una versione ridimensionata dell'immagine (usato per img/thumb delle foto danno)
export const thumbnailify = (base64Image, targetSize, compression = 0.2, mime = 'image/jpeg') => {

  var img = new Image();
  img.src = base64Image;
  return new Promise<string>(resolve => {
    img.onload = () => {
      var oc = document.createElement('canvas'),
        octx = oc.getContext('2d');
      let ratio = (targetSize / img.width);

      oc.width = img.width * ratio;
      oc.height = img.height * ratio;
      octx.drawImage(img, 0, 0, oc.width, oc.height);

      let res = oc.toDataURL(mime, compression);
      resolve(res);
    }
  })

};

export const MD5 = function (d) {
  let result = M(V(Y(X(d), 8 * d.length)));
  return result.toLowerCase()
};

function M(d) { for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++)_ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _); return f }
function X(d) { for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)_[m] = 0; for (m = 0; m < 8 * d.length; m += 8)_[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32; return _ }
function V(d) { for (var _ = "", m = 0; m < 32 * d.length; m += 8)_ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255); return _ }
function Y(d, _) { d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _; for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) { var h = m, t = f, g = r, e = i; f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e) } return Array(m, f, r, i) } function md5_cmn(d, _, m, f, r, i) { return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m) } function md5_ff(d, _, m, f, r, i, n) { return md5_cmn(_ & m | ~_ & f, d, _, r, i, n) } function md5_gg(d, _, m, f, r, i, n) { return md5_cmn(_ & f | m & ~f, d, _, r, i, n) } function md5_hh(d, _, m, f, r, i, n) { return md5_cmn(_ ^ m ^ f, d, _, r, i, n) } function md5_ii(d, _, m, f, r, i, n) { return md5_cmn(m ^ (_ | ~f), d, _, r, i, n) } function safe_add(d, _) { var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m } function bit_rol(d, _) { return d << _ | d >>> 32 - _ }


export const geo_base = { latitude: 45.4641013, longitude: 9.1897378 }

export const copyText = function (val: string) {
  let selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);

}




export const getEmailDomain = function (env) {

  switch (env) {

    case 'ie': return '@i-expert.it';
    case 'gg': return '@general-group.it';
    case 'te': return '@t-econsulting.it';
    case 'tradeone': return '@i-expert.it';
    case 'ev': return '@evolvea-xpert.it';
    case 'nc': return '@nationalclaims.it';
    case 'csi': return '@csi.i-expert.it';
    default: return '@test.it';
  }





}

export const Medializza = function (x) {

  x[0] = (x[0] + x[2]) / 2;
  x[1] = (x[1] + x[3]) / 2;

  let res = new Microsoft.Maps.Location(x[0], x[1]);
  return res;


}



export const lpad = function (s: string, len: number, char: string = '0') {

  char = char.repeat(len)
  s = char + s
  s = s.substr(s.length - len);

  return s

}

export const getFirstWeekDay = function (s: string) {

  try {

    let y = +s.split(' w')[0]
    let w = +s.split(' w')[1]

    //console.log('searching for ', y, w)

    let d = moment(y + '0101')
    while (true) {

      let x = +d.format('W')
      if (x == w) return d.toDate()

      //console.log(d.toDate(), x, w)
      d = d.add(1, 'days');
    }

  } catch (error) {

    return undefined

  }

}



export const getLastWeekDay = function (s: string) {

  try {

    let y = +s.split(' w')[0]
    let w = +s.split(' w')[1]

    //console.log('searching for ', y, w)

    let d = moment(y + '0101')
    while (true) {

      let x = +d.format('W')
      if (x == w) {
        d = d.add(6, 'days');
        return d.toDate()
      }

      //console.log(d.toDate(), x, w)
      d = d.add(1, 'days');
    }

  } catch (error) {

    return undefined

  }



}

// copiato da program-mobile/src/app/shared.ts: usato per filtrare le parti danneggiate in base al colore letto sull'immagine "zone" nascosta
export const getDamageTypes = [
  {
    "code": "G",
    "zone": "Esterni",
    "description": "Graffio"
  },
  {
    "code": "A",
    "zone": "Esterni",
    "description": "Ammaccatura   "
  },
  {
    "code": "F",
    "zone": "Esterni",
    "description": "Fenditura"
  },
  {
    "code": "DF",
    "zone": "Esterni",
    "description": "Deformazione"
  },
  {
    "code": "I",
    "zone": "Esterni",
    "description": "Incidente"
  },
  {
    "code": "P",
    "zone": "Esterni",
    "description": "Puntini sassi"
  },
  {
    "code": "D",
    "zone": "Esterni",
    "description": "Difetto "
  },
  {
    "code": "M",
    "zone": "Esterni",
    "description": "Mancante"
  },
  {
    "code": "R",
    "zone": "Esterni",
    "description": "Rottura"
  },
  {
    "code": "B",
    "zone": "Interni",
    "description": "Bruciatura"
  },
  {
    "code": "F",
    "zone": "Interni",
    "description": "Fenditura"
  },
  {
    "code": "M",
    "zone": "Interni",
    "description": "Mancante"
  },
  {
    "code": "R",
    "zone": "Interni",
    "description": "Rottura"
  },
  {
    "code": "C",
    "zone": "Interni",
    "description": "Consumato"
  },
  {
    "code": "T",
    "zone": "Meccanica",
    "description": "Trafilazione"
  },
  {
    "code": "VAD",
    "zone": "Meccanica",
    "description": "Verifica con diagnosi"
  }
]

export const ZONE_ELEMENTS = [
  {
    "vehType": "Media Compact",
    "code": 1,
    "description": "Paraurti ANT",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "Faro Lato Guida",
    "extra/3": "Faro Lato Passeggero",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 2,
    "description": "Cofano",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Montante porta esterno Lato Guida",
    "extra/1": "Montante porta esterno Lato Passeggero",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 3,
    "description": "Parafango ANT Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Porta ANT Lato Guida",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 4,
    "description": "Parafango ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Porta ANT Lato Passeggero",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 5,
    "description": "Tetto",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": 1,
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 6,
    "description": "Porta ANT Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Parafango ANT Lato Guida",
    "extra/1": "Porta POST Lato Guida",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 7,
    "description": "Porta ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Parafango ANT Lato Passeggero",
    "extra/1": "Porta POST Lato Passeggero",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 8,
    "description": "Porta POST Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Porta ANT Lato Guida",
    "extra/1": "Parafango POST Lato Guida",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 9,
    "description": "Porta POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Porta ANT Lato Passeggero",
    "extra/1": "Parafango POST Lato Passeggero",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 10,
    "description": "Lunotto",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 11,
    "description": "Parafango POST Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": 1,
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Porta ANT Lato Guida",
    "extra/1": "Paraurti POST",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 12,
    "description": "Parafango POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": 1,
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "Porta ANT Lato Passeggero",
    "extra/1": "Paraurti POST",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1010,
    "description": "Portellone POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 13,
    "description": "Paraurti POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 14,
    "description": "Parabrezza",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 16,
    "description": "Porta POST laterale Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 31,
    "description": "Cerchione ANT Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": 1,
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 36,
    "description": "Pannelli porte (Lato Guida o Lato Passeggero)",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1320,
    "description": "Paraurti centrale posteriore",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "1L",
    "description": "Paraurti Anteriore",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "1L01",
    "description": "Sottoporta ANT Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "1R",
    "description": "Paraurti Anteriore",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "1R01",
    "description": "Sottoporta ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "3WA",
    "description": "Modanatura Passaruota ANT Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "4WA",
    "description": "Modanatura Passaruota ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 78,
    "description": "Copri Cerchio",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": 1,
    "#002529": 1,
    "#00254e": 1,
    "#004e4e": 1,
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 80,
    "description": "Borchietta Coprimozzo",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": 1,
    "#002529": 1,
    "#00254e": 1,
    "#004e4e": 1,
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 84,
    "description": "Portatarga",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 100,
    "description": "Proiettore ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 101,
    "description": "Griglia paraurti ANT",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 102,
    "description": "Splitter Paraurti ANT",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 103,
    "description": "Proiettore ANT Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 104,
    "description": "Targa ANT",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 105,
    "description": "Griglia ANT (nel cofano o separata)",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 106,
    "description": "Stemma ANT",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 107,
    "description": "Freccia ANT Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 108,
    "description": "Faro antinebbia Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 109,
    "description": "Modanatura paraurti ANT (Lato Passeggero o Lato Guida)",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 111,
    "description": "Faro antinebbia Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 118,
    "description": "Coppa ruota",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 307,
    "description": "Cerchio ANT Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": 1,
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 408,
    "description": "Cerchio ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": 1,
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 503,
    "description": "Capote COMPLETA",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": 1,
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 504,
    "description": "Tetto apribile",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": 1,
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 560,
    "description": "Barra tetto Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": 1,
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 570,
    "description": "Barra tetto Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": 1,
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 601,
    "description": "Sottoporta Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 602,
    "description": "Modanatura porta ANT Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 603,
    "description": "Serie cilindretti serrature",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 604,
    "description": "Maniglia porta esterna ANT Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 605,
    "description": "Finestrino ANT Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 607,
    "description": "Retrovisore lato guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 609,
    "description": "Vetro fisso ANT Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 612,
    "description": "Cristallo retrovisore Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 701,
    "description": "Sottoporta Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 702,
    "description": "Modanatura porta ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 703,
    "description": "Cilindretto serratura porta ant.",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 705,
    "description": "Vetro scendente ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 707,
    "description": "Retrovisore lato passggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 713,
    "description": "Vetro fisso ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 805,
    "description": "Finestrino POST Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 806,
    "description": "Vetro fisso POST Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 904,
    "description": "Maniglia porta esterna POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 905,
    "description": "Finestrino POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 906,
    "description": "Vetro fisso POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 908,
    "description": "Modanatura paraurti POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1001,
    "description": "Spazzole tergicristallo POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1002,
    "description": "Braccio tergicristallo POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1003,
    "description": "Luce terzo stop",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1114,
    "description": "Cerchione POST Lato Guida (ferro)",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": 1,
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1222,
    "description": "Cerchione POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": 1,
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1223,
    "description": "Arco passaruota POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": 1,
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1302,
    "description": "Spoiler paraurti POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1303,
    "description": "Luce POST Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": 1,
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1304,
    "description": "Targa POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1305,
    "description": "Griglia paraurti ANT inf.",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1306,
    "description": "Stemma POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1307,
    "description": "Freccia POST Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": 1,
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1308,
    "description": "Luce retronebbia posteriore",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1309,
    "description": "Gancio di traino smontabile J",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1311,
    "description": "Fanale POST Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": 1,
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1312,
    "description": "Fanale POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": 1,
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1313,
    "description": "Freccia POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": 1,
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1317,
    "description": "Gancio di traino",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1322,
    "description": "Serratura portello posteriore",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": 1,
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1402,
    "description": "Braccio tergicristallo ANT",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1403,
    "description": "Braccio tergicristallo ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1404,
    "description": "Braccio tergicristallo ANT Lato Guida",
    "#ee1313": "",
    "#3828db": 1,
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1510,
    "description": "Luce di posizione ANT Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1511,
    "description": "Luce di posizione ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1737,
    "description": "Tappetini",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1738,
    "description": "Cinture di Sicurezza",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1804,
    "description": "Coprimozzo",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 4001,
    "description": "Cerchione ANT Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": 1,
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 6061,
    "description": "Freccia retrovisore Lato Guida",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 6071,
    "description": "Freccia retrovisore Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 7302,
    "description": "Ruota di scorta",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "11D",
    "description": "Modanatura montante porta post. Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "11WA",
    "description": "Passaruota/Parasassi Int. ANT, parte ANT/POST",
    "#ee1313": 1,
    "#3828db": "",
    "#26f719": 1,
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "12D",
    "description": "Modanatura montante porta post. Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "6B",
    "description": "Modanatura montante porta ant. Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "7B",
    "description": "Modanatura montante porta ant. Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "8C",
    "description": "Modanatura montante centrale Lato Guida",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": 1,
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": "9C",
    "description": "Modanatura montante centrale Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": 1,
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 302,
    "description": "Modanatura laterale Lato Guida (rifinitura lat.plastica)",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 903,
    "description": "Serratura porta POST",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1105,
    "description": "Vetro laterale POST Lato Guida truck",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1205,
    "description": "Vetro laterale Lato Passeggero truck",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1209,
    "description": "Vetro laterale POST Lato Passeggero truck",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1315,
    "description": "Fascia paracolpi porta carico POST Lato Passeggero",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 1810,
    "description": "Deflettore",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  },
  {
    "vehType": "Media Compact",
    "code": 402,
    "description": "Modanatura laterale Lato Passeggero (rifinitura lat plastica)",
    "#ee1313": "",
    "#3828db": "",
    "#26f719": "",
    "#db6928": "",
    "#3e6928": "",
    "#b1a558": "",
    "#af28db": "",
    "#eaf910": "",
    "#87a5f0": "",
    "#051616": "",
    "#002529": "",
    "#00254e": "",
    "#004e4e": "",
    "extra/0": "",
    "extra/1": "",
    "extra/2": "",
    "extra/3": "",
    "extra/4": ""
  }
]


export const getFilteredElements = (color: string): any[] => {
  return ZONE_ELEMENTS.filter(v => { return v[color] })
}
